module.exports = __webpack_public_path__ + "static/media/learning-budget.59e4216b.svg";